import context from '@/providers/context'
import {dateFromApi} from '@/providers/fields'
import markers from './assets/markers'
import {issuer} from '@/sections/billings/invoices'
import _ from 'lodash'
import Vue from 'vue'

export var addons_names = {
  lat: 'device-latitude',
  lng: 'device-longitude',
  name: 'device-name',
};

var api_location_names = {
  lat: 'latitude',
  lng: 'longitude',
};

export var INTERVALS_WARNING = 3;
export var INTERVALS_ERROR = 5;

//Installation costs (per km and per hour) WITHOUT TAX!
export var COST_KM = 2;
export var COST_H = 50;
export var INSTALLER = {
  lat: 45.9210345,
  lng: 13.6351122,
};

export var technician = _.pick(issuer, ['name', 'email', 'phone']);

export function item_addon_value(item, name) {
  if (name === 'location') {
    return {
      lat: item_addon_value(item, 'lat'),
      lng: item_addon_value(item, 'lng'),
    };
  }
  if (!item.hasOwnProperty('_type')) {
    if (Object.keys(addons_names).includes(name)) {
      name = addons_names[name];
    }
    return item[name];
  }
  if (item._type === 'orders_items') {
    if (Object.keys(addons_names).includes(name)) {
      name = addons_names[name];
    }
    if (!item.addons || !item.addons.length) {
      return null;
    }
    var addon = item.addons.filtered('name', name);
    if (!addon.length) {
      return null;
    }
    return addon.value;
  }
  if (item._type === 'devices' || item._type === 'gateways') {
    if (name === 'name') {
      return item.name;
    } else if (item.locations && item.locations.length) {
      return item.locations.pluck(0)[api_location_names[name]];
    }
    return null;
  }
}

export function device_status(item) {
  /* statuses:
   *  pending - device is ordered item (not device)
   *  processing - not yet installed
   *  error - not yet received data or received more than [INTERVALS_ERROR * device_type.interval] ago
   *  interval - device_type.interval not known
   *  warning - data received than [INTERVALS_WARNING * device_type.interval] ago or interval not known
   *  active - receiving data
  */
  if (!item.hasOwnProperty('_type') && item.status) {
    return item.status;
  }
  if (!['gateways', 'devices'].includes(item._type)) {
    return 'pending';
  }
  if (!item.registered_at) {
    return 'assembly';
  }
  if (!item.installed_at) {
    return 'processing';
  }
  if (item._type === 'gateways') {
    return 'active';
  }
  if (!item.last_data_received_at) {
    return 'error';
  }
  if (!item.hardware_types || !item.hardware_types.length) {
    return 'interval';
  }
  try {
    var interval_seconds = Math.max(1, Number(item.hardware_types.uplink_interval));
    var last_sent = dateFromApi(item.last_data_received_at);
    var seconds_passed = (Date.now() - last_sent.getTime()) / 1000;
    var intervals_passed = seconds_passed / interval_seconds;
    if (intervals_passed > INTERVALS_ERROR) {
      return 'error';
    }
    if (intervals_passed > INTERVALS_WARNING) {
      return 'warning';
    }
    return 'active';
  } catch (e) {
    console.log('Cannot calculate device interval', e, item);
  }
  return 'error';
}

//Returns most pessimistic status
export function grid_status(devices) {
  var statuses = devices.map(device_status);
  var importance = ['error', 'warning', 'active'];
  for (let s of importance) {
    if (statuses.includes(s)) {
      return s;
    }
  }
  return 'empty';
}

//Should be used in a Promise chain
export function normalize_devices(items) {
  if (!Array.isArray(items)) {
    items = items.list;
  }
  return hardware_types()
    .then(h_t =>
      items.map(item => {
        if (item.hasOwnProperty('hardware_types_id')) {
          item.connect(h_t);
        } else if (item.hasOwnProperty('products_id')) {
          item.connectByField(h_t, 'products_id');
        }
        var type;
        var id = item.id;
        if (item._type === 'devices') {
          type = 'device';
        } else if (item._type === 'gateways') {
          type = 'gateway';
          id = 'g' + item.id;
        } else {
          type = 'item';
        }
        var i = {
          id,
          item,
          status: device_status(item),
          type,
        };
        for (let addon of ['name', 'lat', 'lng']) {
          i[addon] = item_addon_value(item, addon);
        }
        i.savename = function () {
          var revert = () => {
            return Vue.set(i, 'name', i.item.name);
          };
          if (i.type !== 'device' && i.type !== 'gateway') {
            return revert();
          }
          var name = i.name;
          return context.getters.api
            .put(i.type + 's/' + i.item.id, {
              name
            })
            .toast(false)
            .then(() => {
              return i.item.set('name', name);
            })
            .catch(e => {
              console.log(e);
              return revert();
            })
          ;
        };
        i.location = null;
        if (i.lat !== null && i.lng !== null && i.lat !== undefined && i.lng !== undefined) {
          i.location = {
            lat: Number(i.lat),
            lng: Number(i.lng),
          };
        }
        return i;
      })
    )
  ;
}

export function device_marker_icon (device, current = false) {
  var icon = 'default_device';
  var opacity = 1;
  var zIndex = 3;
  var device_type = device.type === 'gateway' ? 'gateway' : 'device';
  if (current) {
    switch (device.status) {
      case 'pending':
        opacity = 0.5;
      case 'assembly':
      case 'processing':
        icon = 'default_' + device_type;
        break;
      case 'error':
      case 'interval':
        icon = 'error_device';
        break;
      case 'warning':
        icon = 'warning_device';
        break;
      case 'active':
        icon = 'active_' + device_type;
        break;
    }
    if (device.type !== 'device') {
      zIndex = 2;
    }
  } else {
    zIndex = 1;
    icon = 'faded_' + device_type;
  }
  return {
    title: device.name,
    icon: markers[icon],
    position: device.location,
    opacity,
    zIndex,
  };
}

export function map_options (google) {
  return {
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.LEFT_BOTTOM
    },
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeId: 'hybrid',
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
  };
};

var _hardware_types = null;

export function hardware_types(type = null) {
  if (_hardware_types === null) {
    _hardware_types = context.getters.api.get(
      'hardware_types?range=all&include=products,data_types'
    );
  }
  return _hardware_types.then(types => {
    if (type) {
      return types.filtered('type', type);
    }
    return types;
  });
}

export function sensor_icon(sensor) {
  if (typeof sensor === 'object' && sensor.name_unique) {
    sensor = sensor.name_unique;
  }
  switch (sensor) {
    case 'airHumiditySensor': return 'feelgrid.humidity';
    case 'airTemperatureSensor': return 'feelgrid.temperature';
    default: return 'bargraph';
  }
}

export function sensor_value(value, data_type, decimals = null) {
  var unit;
  if (typeof data_type === 'string') {
    unit = ' ' + data_type;
  } else {
    unit = ' ' + data_type.measurement_unit;
  }
  if (decimals === null) {
    decimals = 1;
    if (typeof data_type === 'object' && data_type.name) {
      if (data_type.name === 'battery_voltage') {
        decimals = 3;
      }
    }
  }
  return Number.parseFloat(value).toFixed(decimals) + unit;
}

export function structure_data(data, data_types = null, structure = ['date', 'device', 'type']) {
  if (data_types === null) {
    alert('Data types fetching not yet implemented');
  }
  var structured = {};
  var flat = [];
  var snake_types = _.uniq(data_types.mapped('name').map(_.snakeCase));
  for (let datum of data) {
    let date = dateFromApi(datum.created_at).getTime();
    let device = datum.devices_id;
    for (let snake_type of snake_types) {
      if (datum.hasOwnProperty(snake_type)) {
        for (let reading of datum[snake_type]) {
          let type = reading.data_types_id;
          let value = reading.value;
          flat.push({
            date, device, type, value,
            item: reading.connect(data_types),
          });
        }
      }
    }
  }
  if (structure && structure.length) {
    var deep = function (items, keys) {
      if (!Array.isArray(items)) {
        items = [items];
      }
      if (!keys.length) {
        if (items.length > 1) {
          console.log('Warning! Some data may be omitted if structured ' + structure.join('.'));
        }
        return items[0];
      }
      var _keys = [].concat(keys);
      var key = _keys.shift();
      var inter = _.groupBy(items, i => i[key]);
      return _.mapValues(inter, o => deep(o, _keys));
    };
    return deep(flat, structure);
  }
  return flat;
}

export function installation_cost(items, gateway) {

  var rad = function(x) {
    return x * Math.PI / 180;
  };
  //distance to INSTALLER, uses Haversine formula
  var distance_from_installer = function (point) {
    var R = 6378137; // Earth’s mean radius in meter
    var lat = Number(item_addon_value(point, 'lat'));
    var lng = Number(item_addon_value(point, 'lng'));

    var dLat = rad(lat - INSTALLER.lat);
    var dLong = rad(lng - INSTALLER.lng);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(INSTALLER.lat)) * Math.cos(rad(lat)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d / 1000; // returns the distance in km
  };

  var nearest = null;
  var hours = Number(gateway.installment_time);
  for (let device of items) {
    hours += Number(device.device_type.installment_time);
    let distance = distance_from_installer(device);
    if (nearest === null || distance < nearest) {
      nearest = distance;
    }
  }
  var sum = hours * COST_H;
  if (nearest !== null) {
    sum += nearest * COST_KM;
  }
  return sum;
}


// WEBPACK FOOTER //
// ./src/apps/feelgrid/helpers.js